import { IconType } from '@svg/index';

export const DEFAULT_ICON_PROPS = {
  width: 32,
  height: 32,
  color: 'currentColor',
} satisfies Partial<IconType>;
